import React, { useState } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import MasterLeftPanel from "../include/MasterLeftPanel";
import Global from "../../APIConfig";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import AuthUser from "../../AuthUser";

function ZoneAdd()
{
    const navigate = useNavigate();
    const [zonename, setZonename] = useState('');
    const [zonetype, setZonetype] = useState('');
    const{headers1,headers2,logout}=AuthUser();
    const [Loading, setLoading] = useState(false);

    const handleSubmit=()=>{
        if(zonename =='')
        {
            toast.warn('Please Enter Zone Name');
        }
        else if(zonetype == '')
        {
            toast.warn('Please Select Zone Type');
        }
        else
        {
            setLoading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'CreateZone',
                headers:headers1,
                data: {
                    name: zonename,
                    zone_type: zonetype,

                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                    setTimeout(() => {
                        navigate('/zoneList/All'); 
                    }, 1000);
                }
                else
                {
                    if(response.data.message.name.length>0)
                    {
                        toast.warn(response.data.message.name[0]);
                    }
                    else if(response.data.message.zone_type.length>0)
                    {
                        toast.warn(response.data.message.zone_type[0]);
                    }
                    else{
                        toast.warn(response.data.message);
                    }
                    
                }
                setLoading(false);
            })
            .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                setLoading(false);
                // console.log(error);
              });
        }
    }

    return (
        <>
            <MasterLeftPanel />
            <main className='home-section'>
                <Header />
                <ToastContainer />
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                <li className="breadcrumb-item">
                                    <a href="/Admin-Dash">
                                        <i className="bx bx-home text-primary-400 fs-6"></i>
                                    </a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">Zone</li>
                            </ol>
                        </nav>
                        <div className="d-flex justify-content-between">
                            <div className="">
                                <button className="btn btn_nav btn-sm" onClick={() => navigate(-1)}>
                                    <i className="bx bx-arrow-back "></i>
                                </button>
                            </div>
                            <div className="ps-2 ">
                                <h2 className="h4">Create Zone</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-md">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-8 mb-3">
                                        <label htmlFor="" className="form-label">Zone Name <small className="text-danger">*</small> </label>
                                        <input type="text" className="form-control" id="" placeholder="Please Enter Zone Name" value={zonename} onChange={(e)=>setZonename(e.target.value)} />
                                    </div>
                                    <div className="col-8 mb-3">
                                        <label htmlFor="" className="form-label">Zone Type <small className="text-danger">*</small></label>
                                        <select className="form-control" onChange={(e)=>setZonetype(e.target.value)}>
                                            <option value="">Please Select</option>
                                            <option value="Domestic">Domestic</option>
                                            <option value="International">International</option>
                                        </select>
                                    </div>
                                     
                                </div>
                                {Loading==false?
                                    <div className="d-grid col-md-2 mt-2">
                                        <button className="btn btn-primary" onClick={()=>handleSubmit()}>Create Zone</button>
                                    </div>
                                    :
                                    <div className="d-grid col-md-2 mt-2">
                                        <a href="" className="btn btn-primary btn-block"> <div className="spinner-border text-light" role="status"><span className="visually-hidden">Loading...</span></div></a>
                                    </div>
                                    }
                            </div>
                        </div>
                    </div>
                    
                </div>
                <Footer />
            </main>
        </>
        );
}
export default ZoneAdd;